import {makeStyles} from "@material-ui/core/styles";
import { Children } from "react";

export default makeStyles(
    {
        container:{
            padding: '0 5%',
            width:'100%',
            margin: 0,
        },
        container1:{
            padding:'0 5%',
            width:'100%',
            margin:'0',
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center'
        },
        image:{
            width:'50rem',
            alignItems:'center',
            // left:'30px'
        },
        cards:{
            margin:'30px',
            height:'350px',
            width:'250px',
            backgroundColor:'purple',
            color:'white',
            textAlign:'center',
            padding:'10px',
            borderRadius:'10px',
            boxShadow:'0 0 5px 5px rgba(0,0,0,0.5)',
            
        },

    }
);